import * as React from "react";
import { GetPage, StoredMedication, dbQueries } from "duck";
import AutoComplete from "../base";
import { AutoCompleteProps } from "../base/AutoComplete";

const Medications = <TMulti extends boolean = false>(
  props: Omit<AutoCompleteProps<StoredMedication, TMulti>, "getPage">
) => {
  const getPage = React.useCallback<GetPage<StoredMedication>>(
    (_, variables) => dbQueries.loadMedications(variables),
    []
  );
  return <AutoComplete<any, TMulti> getPage={getPage} {...props} />;
};

export default Medications;
